document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.card-wrapper');

  cards.forEach((card) => {
    const video = card.querySelector('.card-product-video');
    if (!video) return;

    // Detectar si és dispositiu tàctil (no hi ha hover real)
    const isTouchDevice = window.matchMedia('(hover: none)').matches;

    if (isTouchDevice) {
      // A mòbil: reproduir només quan és visible al viewport
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
              video.currentTime = 0;
            }
          });
        },
        { threshold: 0.6 }
      );
      observer.observe(video);
    } else {
      // A desktop: reproduir al hover
      card.addEventListener('mouseenter', () => {
        video.play().catch(() => {});
      });

      card.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    }
  });
});